import * as yup from "yup";

import { categoryImage, categoryName } from "./categoryValidation";

export const CategorySchema = (isMainCategory: boolean) =>
  yup.object({
    name: categoryName(isMainCategory ? "Category name" : "Sub-category name"),
    image: categoryImage(isMainCategory)
  });
